import script from "./MessagesView.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagesView.vue?vue&type=script&setup=true&lang=js"

import "./MessagesView.vue?vue&type=style&index=0&id=c452efd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c452efd8"]])

export default __exports__